import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'ua' : 'en';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  const navigation = [
    { name: t('nav_veterans'), href: '/veterans' },
    { name: t('nav_families'), href: '/families' },
    { name: t('nav_outreach'), href: '/outreach' },
    { name: t('nav_ptsd_education'), href: '/ptsd-education' },
    { name: t('nav_tld'), href: '/tld' },
    { name: t('nav_about'), href: '/about' },
    { name: t('nav_contact'), href: '/contact' },
  ];

  return (
    <header className="fixed w-full top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-stone-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://static.readdy.ai/image/e7605311edff4188dbd664db0f9809d3/f17a003f3d23c1164cef4e6ee6113553.png" 
              alt="Valhalla on Earth Logo" 
              className="h-12 w-12"
            />
            <span className="font-medium text-lg text-stone-800">Valhalla on Earth</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors duration-200 hover:text-amber-600 whitespace-nowrap ${
                  location.pathname === item.href
                    ? 'text-amber-600 border-b-2 border-amber-600'
                    : 'text-stone-700'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Language Toggle & Mobile Menu */}
          <div className="flex items-center space-x-4">
            {/* Language Toggle */}
            <button
              onClick={toggleLanguage}
              className="flex items-center h-10 px-3 rounded-full border border-stone-300 bg-white hover:bg-stone-50 transition-colors duration-200"
            >
              <span className={`px-2 py-1 text-sm font-medium rounded-full transition-all duration-200 ${
                i18n.language === 'en' ? 'bg-stone-800 text-white' : 'text-stone-600'
              }`}>
                {t('language_en')}
              </span>
              <span className="mx-1 text-stone-400">|</span>
              <span className={`px-2 py-1 text-sm font-medium rounded-full transition-all duration-200 ${
                i18n.language === 'ua' ? 'bg-stone-800 text-white' : 'text-stone-600'
              }`}>
                {t('language_ua')}
              </span>
            </button>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 rounded-md text-stone-700 hover:text-stone-900 hover:bg-stone-100"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
              </div>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-white z-40">
          <div className="px-4 py-6 space-y-6">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="block text-lg font-medium text-stone-700 hover:text-amber-600 transition-colors duration-200"
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}